import React from 'react';
import {useLanguage} from "../../contexts/LanguageContext.tsx";
import ContactSection from "./contactSection.tsx";
import {ContactType} from "./contactType.ts";

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactModal: React.FC<ContactModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;
  const { translations } = useLanguage();

  const listContact : ContactType[] =  [
    {
      location: translations.Braunschweig,
      contacts: [
        {
          name: 'Katja Ludwig',
          image: '../../assets/Pictures/Katja_Ludwig-contact.png',
          status: translations.Reception,
          email: 'mail@novobit.eu',
          phone: '+49 531 680940-0',
          address : 'Theodor-Heuss-Straße 2',
          location1: '38122 Braunschweig',
          city: translations.contactGermany,
        },
        {
          name: 'Michael Rix',
          image: '../../assets/Pictures/Michael_Rix.jpg',
          status: translations.Head_of_Sales,
          email: 'm.rix@novobit.eu',
          phone: '+49 152 59599402',
        }
      ],

    },
    {
      location: translations.Tunis,
      contacts: [
        {
          name: 'Nada Hamzaoui',
          image: '../../assets/Pictures/nada-contact.png',
          status: 'CEO Tunis',
          email: 'sarl@novobit.eu',
          address : 'Rue Lac Malären',
          location1: 'Immeuble La Citadelle',
          location2: 'Les Berges du Lac 1',
          city: '1053 Tunis',
        },
        {
          name: 'Khloulod Soltani',
          image: '../../assets/Pictures/khouloud_soltani.jpg',
          status: 'Office Manager',
          email: 'k.soltani@novobit.eu',
          location1: translations.Contact_Tunis,
        }
      ],

    },
    {
      location: translations.Dubai,
      contacts: [
        {
          name: 'Andreas Simon',
          image: '../../assets/Pictures/Andreas_Simon.jpg',
          status: 'Sales Director Middle East',
          email: 'a.simon@novobit.ai',
          phone:'+971 547604760',
          address : 'Building 3, Office 106',
          location1: 'P.O. Box 500015',
          city: 'Dubai, United Arab Emirates',
        },
        {
          name: 'Jean Fideli',
          image: '../../assets/Pictures/Jean_Fideli_contact.jpg',
          status: 'Business Development',
          email: 'j.fideli@novobit.ai',
          phone: '+971 501435185',
        }
      ],

    },

  ]

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-7xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 pt-0">
          <div className="flex justify-between items-start sticky-btn ">
            <h3 className="text-2xl font-light"></h3>
            <button
                onClick={onClose}
                className="bg-gray-400/50 hover:bg-gray-500/50 transition-colors rounded-full p-2"
            >
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="p-5">
            <div>
              <h2 className="text-[#3f4651] font-light uppercase text-4xl text-center">{translations.contact}</h2>
            </div>
            <div className="bg-[#e2d3b6] rounded-xl mt-4">
              <div className="p-5 grid md:flex md:justify-center gap-10">
                {listContact.map((item, index) => {
                  return <ContactSection data={item} key={index} />
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
